import React, { ReactNode, useState } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { giphyWhite } from '@giphy/js-brand'

const Toggle = styled.span`
    cursor: pointer;
    user-select: none;
`

const ToggleIcon = styled.i<{ isOpen: boolean }>`
    display: inline-block;
    font-size: 10px;
    height: 10px;
    margin-left: 6px;
    width: 10px;
    transition: color 0.1s ease-out, transform 0.1s ease-out;
    transform-origin: 5px 10px;

    ${props =>
        props.isOpen &&
        css`
            color: ${giphyWhite};
            transform: rotate(90deg) translate3d(1px, 0, 0);
        `}
`

const inputWrapperIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

const InputWrapper = styled.div`
    margin: 10px 0;
    animation: ${inputWrapperIn} 0.2s ease-out;
`

type Props = {
    className: string
    children: ReactNode
    label: string
}

const CollapseField = ({ className = '', children, label }: Props) => {
    const [isOpen, setIsOpen] = useState(false)

    const onToggleOpen = () => {
        setIsOpen(prev => !prev)
    }

    return (
        <div className={className}>
            <Toggle onClick={() => onToggleOpen()}>
                {label} <ToggleIcon isOpen={isOpen} className="ss-directright" />
            </Toggle>
            {isOpen && <InputWrapper>{children}</InputWrapper>}
        </div>
    )
}

export default CollapseField
